import React from "react";
import { useTable } from "react-table";
import { SortableContainer } from "react-sortable-hoc";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import { styles } from "./styles";
import SortableRow from "./SortableRow";

const RearrangableTable = SortableContainer(({ columns, data, itemActionButtons, reOrder, classes }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    data,
    columns
  });

  return (
    <TableContainer component={Paper}>
      <Table {...getTableProps()}>
        <TableHead classes={{ root: classes.tableHead }}>
          {headerGroups.map((headerGroup, i) => (
            <TableRow key={`headerGroup-${i}`} {...headerGroup.getHeaderGroupProps()}>
              {reOrder ? <TableCell key={`dummyHeader-${i}`}></TableCell> : null}
              {headerGroup.headers.map((column) => {
                return (
                  <TableCell
                    key={column.Header}
                    classes={{ head: classes.tableHeadCell }}
                    {...column.getHeaderProps()}
                    children={column.render("Header")}
                  />
                );
              })}
              {!_.isEmpty(itemActionButtons) ? (
                <TableCell key={`dummyCell-${i}`} classes={{ head: classes.tableHeadCell }}>
                  Actions
                </TableCell>
              ) : null}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row, index) => {
            prepareRow(row);
            return (
              <SortableRow
                itemActionButtons={itemActionButtons}
                key={`item-${index}`}
                index={index}
                row={row}
                reOrder={reOrder}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
export default withStyles(styles)(RearrangableTable);
